import Select from './components/configurator/Select';
import Store from './components/configurator/Store';
import FilterTaber from './components/configurator/FilterTaber';
import Validation from './components/configurator/Validation';
import Helper from './components/configurator/Helper';
import StickerBuilder from "./components/preview/StickerBuilder";
import Preview from "./components/preview/Preview";

(function ($) {
  if($('body.configurator-product').length) {
    wc_single_product_params.photoswipe_enabled = false;
  }

  wc_single_product_params.zoom_enabled = false;

  let productWasNotUpdated = true;

  $(document).on('woocommerce_gallery_init_zoom', function () {
    if($('body.configurator-product').length) {
      let $wrapper = $('.woocommerce-product-gallery')
      let $firstItem = $wrapper.find('.woocommerce-product-gallery__image:first');
      let $firstItemLink = $firstItem.find('> a');
      let $firstThumbNav = $wrapper.find('.flex-control-nav');
      let thumb = $firstItem.attr('data-o_data-thumb');
      let link = $firstItemLink.attr('data-o_href');

      $firstItem.attr('data-thumb', thumb);
      $firstItemLink.attr('href', link);
      $firstThumbNav.find(`[data-o_src="${thumb}"]`).attr('src', thumb);

      if(productWasNotUpdated) {
        let $amount = $('#pa_label-amount');

        if($amount.length) {
          let amountValue = $amount.val();

          if(amountValue) {
            let $selectPrice = $('#configurator_select_price');
            let $item = $selectPrice.find(`.price[data-value="${amountValue}"]`);
            let $label = $selectPrice.find('.configurator-select-selected .label');
            let key = $selectPrice.find('input').attr('name');
            let $left = $item.find('.left-label').clone();

            let amount = $item.attr('data-value');
            let price = $item.attr('data-price');
            let payload = {key, price, amount};
            let $wrapper = $('<div class="value"></div>');

            $label.html($left);
            $label.append($wrapper);

            if($item.find('del').length) {
              let $del = $item.find('del').clone();
              let $ins = $item.find('ins').clone();

              $label.find('.value').append($del);
              $label.find('.value').append($ins);
            }else {
              let $amount = $item.find('.amount').clone();

              $label.find('.value').append($amount);
            }

            $(document).trigger('configurator-select:selected-price', payload);
          }
        }
        let $protection = $('#pa_extra-protection');

        if($protection.length) {
          let protectionValue = $protection.val();

          if(protectionValue === 'yes') {
            $('#configurator_protection').prop('checked', true);
          }
        }

        productWasNotUpdated = false;
      }
    }
  });

  let stickerTimeout = null;
  let variationTimeout = null;
  let lang = $('html').attr('lang').split('-')[0];
  /**
   * TODO Switch this when will be installed WPML
   */
    // let langPostfix = lang === 'nl' ? '' : `-${lang}`;
  let langPostfix = lang === 'nl' ? '' : ``;
  let configuratorValidation = new Validation({
    rules: {
      'first_name': 'required|required_if_empty:last_name',
      'last_name': 'required|required_if_empty:first_name',
      'model': 'required',
      'image': 'required',
      'font': 'required',
      'background': 'required',
      'text_color': 'required',
      'amount': 'required',
    }
  });
  let stickerPreview = new Preview({
    id: 'sticker-preview-canvas'
  });
  let stickerImage = new Preview({
    id: 'sticker-image-canvas'
  });
  let stickerBuilder = new StickerBuilder();
  let configuratorStore = new Store();
  let configuratorHelper = new Helper();

  $(document).on('woocommerce_variation_has_changed', function () {
    if (variationTimeout !== null) {
      clearTimeout(variationTimeout);
    }

    variationTimeout = setTimeout(() => {
      configuratorHelper.setProtection($('#configurator_protection'), langPostfix, configuratorStore);
    }, 20);
  }).on('keydown', '#configurator_personal_message', function(e) {
    let value = $(this).val();

    if(value.length >= 255) {
      if(e.keyCode !== 8) {
        return false;
      }
    }
  }).on('focusout', '#configurator_personal_message', function(e) {
    let value = $(this).val();

    if(value.length >= 255) {
      value = value.substring(0, 255);
      $(this).val(value);
    }
  }).on('click', '#configuratior_add_to_cart', function () {
    if(configuratorValidation.isValid(configuratorStore.all())) {
      var labelClone = $('#label_preview').clone().wrap("<div />").parent().html();
      localStorage.setItem('label_preview', labelClone);

      var labelItems = $('#configurator_select_price .price.selected').data('value');
      localStorage.setItem('label_items', labelItems);

      var productTitle = '';
      var model = $('#configurator_select_model .configurator-select-body .model.selected');
      if(model.length && model.is(':visible')){
        productTitle = model.find('.label').text();
      }
      localStorage.setItem('product_title', productTitle);

      $.siteLoader.toggle($('#site-loader'), 'show');
      $(this).closest('form').submit();
    }

    return false;
  }).on('sort-taber:init', function (e, payload) {
    new FilterTaber(payload.list);
  }).on('configurator-select:selected', function (e, payload) {
    let clearedKey = payload.key.replace('configurator[', '');

    clearedKey = clearedKey.replace(']', '')
    configuratorStore.set(clearedKey, payload.value);
    generatePreview();
  }).on('configurator-select:selected-border-color', function(e, payload) {
    configuratorStore.set('image_border', payload);
  }).on('configurator-select:selected-price', function (e, payload) {
    let $amount = $('#pa_label-amount');

    $amount.val(payload.amount);
    $amount.trigger('change');

    let $protection = $('#configurator_checkbox_protection');
    let $protectionInfo = $protection.find('.info');

    if($protectionInfo.length) {
      let stringData = $protectionInfo.attr('data-prices');
      let data = JSON.parse(stringData);

      if(data.hasOwnProperty(payload.amount)) {
        $protectionInfo.html(data[payload.amount]);
      }
    }
  }).on('change', '#configurator_protection', function () {
    configuratorHelper.setProtection($(this), langPostfix, configuratorStore);
  }).on('woocommerce_variation_has_changed', function () {
    configuratorHelper.configuratorToggleSubmit(configuratorStore, configuratorValidation);
  });

  new Select({
    selector: '.configurator-select'
  });

  $(window).on('load', function () {
    $('#configurator_select_price [data-most-chosen]').each(function (index, el) {
      let message = $(el).attr('data-most-chosen');

      if(message) {
        $(el).append(`<span class="most-chosen">${message}</span>`);
      }
    });

    $('#configurator_select_price [data-description]').each(function (index, el) {
      let description = $(el).attr('data-description');

      if(description) {
        $(el).prepend(`<span class="description">${description}</span>`);
      }
    });
    if($('#configurator_select_price .price').length == 1){
      $('#configurator_select_price .price').trigger('click');
    }
  });

  configuratorStore.set('first_name', 'Lucky');
  configuratorStore.set('last_name', 'Labels');

  let $firstName = $(`#configurator_first_name`);
  let $lastName = $(`#configurator_last_name`);

  $firstName.val(configuratorStore.get('first_name'));
  $lastName.val(configuratorStore.get('last_name'));
  $firstName.addClass('default-value');
  $lastName.addClass('default-value');

  $(document).on('focusin', '.default-value', function () {
    let name = $(this).attr('name');

    configuratorStore.set(name, '');
    $(this).removeClass('default-value').val('');
    $(this).trigger('change');
    generatePreview();
  }).on('focusout', '#configurator_first_name, #configurator_last_name', function () {
    let firstName = $firstName.val();
    let lastName = $lastName.val();
    let fullName = firstName + ' ' + lastName;
    if(!fullName.trim()){
      fullName = 'Lucky Labels';
    }

    configuratorStore.set('first_name', firstName);
    configuratorStore.set('last_name', lastName);
    $('#configurator_select_fonts .item .label').html(fullName);
    configuratorHelper.configuratorToggleSubmit(configuratorStore, configuratorValidation);

    generatePreview();
  }).on('keydown', '#configurator_first_name, #configurator_last_name', function (e) {
    //For old Android
    let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    let isOld = /Android [1-5]./i.test(navigator.userAgent);
    let max = isMobile ? 23 : 24;
    let value = $(this).val();

    if (value.length >= max) {
      if (isMobile && isOld) {
        max = max - 1;
        $(this).val(value.substr(0, max));
      } else {
        e.preventDefault();
      }
    }
  });

  $(document).on('preview:generated', function (e, payload) {
    let $imageWrappers = $('.woocommerce-product-gallery__wrapper a');
    // let img = `<img src="${payload.url}" class="sticker-gallery-preview ${payload.model}" alt=""/>`;
    let img = `<div class="d-flex justify-content-center align-items-center sticker-gallery-preview ${payload.model}">${payload.url}</div>`;

    $('#configurator_preview_source').val(payload.url);
    $('#configurator_preview_width').val(payload.width);
    $('#configurator_preview_first_name_size').val(payload.first_name_size.toFixed(2));
    $('#configurator_preview_last_name_size').val(payload.last_name_size.toFixed(2));
    $imageWrappers.find('.sticker-gallery-preview').remove();
    $imageWrappers.append(img);
  }).on('preview::get-sticker-data', function () {
    let settings = {
      font_family: configuratorStore.get('fonts'),
      background: configuratorStore.get('background'),
      text_color: configuratorStore.get('text_color'),
      image: configuratorStore.get('image'),
      image_border: configuratorStore.get('image_border'),
      model: configuratorStore.get('model'),
      first_name: configuratorStore.get('first_name'),
      last_name: configuratorStore.get('last_name'),
      data_only: false,
    };
    let sticker = stickerBuilder.getByType(configuratorStore.get('model'), settings);

    stickerPreview.generate(sticker.getAll());
  });

  function generatePreview() {
    if (stickerTimeout !== null) {
      clearTimeout(stickerTimeout);
    }

    stickerTimeout = setTimeout(() => {
      $(document).trigger('preview::get-sticker-data');
    }, 100);
  }

  generatePreview();

  $(document).on('click', '.woocommerce-product-gallery', function (e) {
    e.stopPropagation();
    e.preventDefault();
    return false;
  });
}(jQuery));